import * as React from 'react';

import classnames from 'classnames';

import type {DashboardStatsFragment as Stat} from 'nutshell-graphql-types';

import {StatsBar} from '../stats-bar/stats-bar';

type Props = {
    statsProps?: {
        stats: Stat[];
        isHorizontal?: boolean;
    };
    content: React.ReactNode;
};

export function DashboardCardMainContent(props: Props) {
    const className = classnames('flex', 'full-width', 'full-height', {
        ['flex-dir-col']: props.statsProps && props.statsProps.isHorizontal,
    });

    return (
        <div className={className}>
            {props.statsProps && (
                <div>
                    <StatsBar {...props.statsProps} />
                </div>
            )}
            {props.content}
        </div>
    );
}
